import React from "react";
import PropTypes from "prop-types";
import Breadcrumb from "shared/components/navigation/breadcrumb/Breadcrumb";
import Text from "shared/components/data-display/text/Text";
import VStack from "shared/components/layout/stack/VStack";

const SectionHead = ({ title, description, menuOptions }) => {
    return (
        <VStack spacing="One">
            {menuOptions && <Breadcrumb menuOptions={menuOptions} />}
            <VStack spacing="Zero_5">
                {title && (
                    <Text variant="Headline_2" color="Gray_1">
                        {title}
                    </Text>
                )}
                {description && (
                    <Text variant="Body_2_1" color="Gray_2">
                        {description}
                    </Text>
                )}
            </VStack>
        </VStack>
    );
};

SectionHead.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    menuOptions: PropTypes.array,
};

export default SectionHead;
